export default "__VITE_PUBLIC_ASSET__bfa44fcf__"